

















































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import { IDossierMovements } from '@/store/models/IDossierMovements';

@Component({ components: { Snackbar } })
export default class DossierMovements extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;

  dossierApi = new DossierApi();
  groupedMovements: any[] = [];
  expanded: any[] = [];
  loadingMovements = false;

  // 🔹 Cabecera principal
  movementHeaders = [
      { text: 'Code', value: 'code' },
      { text: 'Company Source', value: 'companySource' },
      { text: 'Warehouse Source', value: 'warehouseSource' },
      { text: 'Company Destination', value: 'companyDestination' },
      { text: 'Warehouse Destination', value: 'warehouseDestination' },
      { text: 'Date', value: 'date' },
      { text: 'Total Goods', value: 'totalGoods' }
  ];

  // 🔹 Cabecera del detalle expandido
  movementDetailHeaders = [
      { text: 'Good', value: 'goodName' },
      { text: 'Pallet Type', value: 'palletType' },
      { text: 'Pallet Id', value: 'idPallet' },
      { text: 'Cases/Pallet', value: 'casesPerPallet' },
      { text: 'Goods/Case', value: 'goodsPerCase' },
      { text: 'Total Goods', value: 'totalGoods' }
  ];

  async mounted() {
      await this.loadMovements();
  }

  /** 🔹 Carga los movimientos desde la API y agrupa por idGoodsMovement */
  async loadMovements() {
      if (!this.inboundCode) return;
      this.loadingMovements = true;

      try {
          const data: IDossierMovements[] = await this.dossierApi.GetMovements(this.inboundCode);
          // Agrupamos por idGoodsMovement
          this.groupedMovements = Object.values(
              data.reduce((acc: any, curr: IDossierMovements) => {
                  const key = curr.idGoodsMovement || curr.id;
                  if (!acc[key]) {
                      acc[key] = {
                          rowKey: key,
                          idGoodsMovement: curr.idGoodsMovement,
                          code: curr.code,
                          companySource: curr.companySource,
                          warehouseSource: curr.warehouseSource,
                          companyDestination: curr.companyDestination,
                          warehouseDestination: curr.warehouseDestination,
                          date: curr.date,
                          totalGoods: 0,
                          details: [] as any[]
                      };
                  }

                  acc[key].details.push({
                      goodName: curr.goodName,
                      palletType: curr.palletType,
                      idPallet: curr.idPallet,
                      casesPerPallet: curr.casesPerPallet,
                      goodsPerCase: curr.goodsPerCase,
                      totalGoods: curr.totalGoods
                  });

                  acc[key].totalGoods += curr.totalGoods || 0;
                  return acc;
              }, {})
          );

          console.log('📦 Grouped Movements:', this.groupedMovements);
      } catch (err) {
          console.error('❌ Error loading movements:', err);
      } finally {
          this.loadingMovements = false;
      }
  }

  formatDate(date: Date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString();
  }
}
